import React, { useState } from 'react';
import { MuiFormBuilder } from 'components';

import uiSchema from './uiSchema';
import driverUiSchema from './driver/uiSchema';
import schema from './schema';
import driverSchema from './driver/schema';
import { useSelector } from 'react-redux';
import { hasRequiredRole } from 'helpers';

const Form = ({ init, setFilter }) => {
  const formData = { ...init };
  const [startDisable, setStartDisable] = useState(true);
  const [endDisable, setEndDisable] = useState(true);

  const onChange = async ({ formData }) => {
    setFilter({
      ...formData,
      start_time: formData?.min_created_at ? `${formData?.start_time}` : '',
      end_time: formData?.max_created_at ? `${formData?.end_time}` : '',
    });
    setStartDisable((prev) => !Boolean(formData?.min_created_at));
    setEndDisable((prev) => !Boolean(formData?.max_created_at));
  };

  const { taskTypes } = useSelector((state) => state.models);
  // const { operationTypes } = useSelector((state) => state.models);
  // const { materialTypes } = useSelector((state) => state.models);
  // const { shiftTypes } = useSelector((state) => state.models);
  const { taskStatuses } = useSelector((state) => state.models);

  const { isAuthenticated, userInfo } = useSelector((state) => state.auth);
  const isDriver = isAuthenticated && hasRequiredRole(['driver'], userInfo?.roles);

  return (
    <MuiFormBuilder
      showSubmit={false}
      formContext={{ clearable: true }}
      schema={isDriver ? driverSchema() : schema()}
      uiSchema={isDriver ? driverUiSchema(startDisable, endDisable) : uiSchema(startDisable, endDisable)}
      formData={formData}
      onChange={onChange}
    />
  );
};

export default Form;
